
export default {
  data() {
    return {
      dialogVisible: false
    }
  }
}
